import Icon from "../Icon";
import { esGestor, nombreRol } from "../../utils";
import { PAGE_META } from "./pageMeta";

// Menu lateral y su velo en movil. Sin estado propio: lo decide el armazon (App).

export default function Sidebar({ sidebarExpanded, setSidebarExpanded, setSidebarPeek, sidebarOpen, isMobile, hover, page, go, setModal, verIncidencias, verMisTareas, verUsuarios, currentUser, integrations, onLogout }) {
  return (
    <>
      {sidebarExpanded&&isMobile&&(
        <div onClick={()=>setSidebarExpanded(false)}
          style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:9,backdropFilter:"blur(2px)"}}/>
      )}
      <aside className="sl"
        onMouseEnter={()=>{ if(hover&&!isMobile&&!sidebarExpanded) setSidebarPeek(true); }}
        onMouseLeave={()=>{ if(hover&&!isMobile) setSidebarPeek(false); }}
        style={{
        // Cajon de 300px y no 100vw: a pantalla completa el velo de detras
        // quedaba tapado del todo y el "pulsar fuera para cerrar" era
        // inalcanzable; la unica salida era la X.
        width: isMobile ? "min(84vw,300px)" : (sidebarOpen ? 224 : 64),
        minWidth: isMobile ? "min(84vw,300px)" : (sidebarOpen ? 224 : 64),
        background:"#0B2849",
        borderRight:"1px solid #244b78",
        display:"flex",flexDirection:"column",
        flexShrink:0,zIndex:10,
        overflow:"hidden",
        transition:"width .25s ease,min-width .25s ease,left .25s ease",
        position: isMobile ? "fixed" : "relative",
        top: isMobile ? 0 : "auto",
        left: isMobile ? (sidebarExpanded ? 0 : -320) : "auto",
        // dvh y no vh: en moviles la barra de direcciones se cuenta dentro de
        // 100vh y el pie del sidebar (perfil / cerrar sesion) quedaba cortado.
        height: isMobile ? "var(--vh100)" : "auto",
        boxShadow: isMobile&&sidebarExpanded ? "4px 0 24px rgba(0,0,0,.3)" : "none",
      }}>
        {/* Cabecera sidebar */}
        <div style={{padding:"12px 10px",borderBottom:"1px solid #244b78",display:"flex",alignItems:"center",
          gap:8,justifyContent:sidebarOpen?"space-between":"center",flexShrink:0}}>
          {sidebarOpen&&(
            <div style={{display:"flex",alignItems:"center",flex:1,minWidth:0}}>
              <img src={`${process.env.PUBLIC_URL}/brand/logo-horizontal-dark.svg`} alt="Ángel Linares — Manager"
                style={{display:"block",height:34,width:"auto",maxWidth:"100%"}}/>
            </div>
          )}
          {/* Toggle button */}
          <button onClick={()=>{ const next=!sidebarExpanded; setSidebarExpanded(next); if(!next) setSidebarPeek(false); }} title={sidebarExpanded?"Cerrar menú":"Fijar menú abierto"} aria-label={sidebarExpanded?"Cerrar menú":"Fijar menú abierto"}
            style={{flexShrink:0,width:32,height:32,borderRadius:8,
              background:"rgba(0,180,216,.12)",border:"1px solid rgba(0,180,216,.25)",
              cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",transition:"all .15s"}}
            onMouseEnter={e=>e.currentTarget.style.background="rgba(0,180,216,.25)"}
            onMouseLeave={e=>e.currentTarget.style.background="rgba(0,180,216,.12)"}>
            {isMobile
              ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#96E6F0">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                </svg>
              : sidebarExpanded
                ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#96E6F0">
                    <path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5-1v12h9a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM4 2H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2z"/>
                  </svg>
                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#96E6F0">
                    <path d="M14 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z"/>
                    <path d="M3 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>
                  </svg>
            }
          </button>
        </div>
        <nav style={{flex:1,padding:"10px 6px",overflowY:"auto"}}>
          {/* Icono y etiqueta salen de pageMeta: la cabecera usa la misma fuente, asi
              que el menu y la pagina a la que lleva nunca se contradicen. */}
          {["home",...(verMisTareas?["tareas"]:[]),"projects","cuaderno","calendario","fichajes",
            ...(verIncidencias?["helpdesk"]:[]),
            ...(esGestor(currentUser)?["teams"]:[]),
            ...(verUsuarios?["users"]:[]),
          ].map((pg,i)=>{
            const ic = PAGE_META[pg].icon, lb = PAGE_META[pg].label;
            const active = page===pg;
            // El color de cada pagina vive en la barra y el tinte, que no son texto. Texto e
            // icono van en cian claro (activo) o casi blanco (hover) para leerse sobre el tinte.
            // Inicio es #0b7d96 en la cabecera (fondo claro); en el menu oscuro va en #50CCE4.
            const col = pg==="home" ? "#50CCE4" : (PAGE_META[pg]?.color || "#96E6F0");
            return (
              <button key={pg} className={`nav fu s${i+1}`} onClick={()=>go(pg)}
                title={!sidebarOpen?lb:""} aria-label={lb} aria-current={active?"page":undefined}
                onMouseEnter={e=>{if(!active){e.currentTarget.style.color="#cee8f0";e.currentTarget.style.background=col+"18";}}}
                onMouseLeave={e=>{if(!active){e.currentTarget.style.color="#8fb8c8";e.currentTarget.style.background="transparent";}}}
                style={{width:"100%",display:"flex",alignItems:"center",position:"relative",
                  gap:sidebarOpen?9:0,
                  padding:sidebarOpen?"8px 10px":"8px 0",
                  justifyContent:sidebarOpen?"flex-start":"center",
                  borderRadius:8,border:"none",cursor:"pointer",fontFamily:"var(--font)",marginBottom:2,fontSize:12.5,
                  background:active?col+"30":"transparent",
                  color:active?"#96E6F0":"#8fb8c8",fontWeight:active?700:400,
                  transition:"background .13s,color .13s"}}>
                {active&&<span style={{position:"absolute",left:0,top:"15%",bottom:"15%",width:3.5,borderRadius:"0 3px 3px 0",background:col,boxShadow:`0 0 8px ${col}88`}}/>}
                <Icon name={ic} size={15} color={active?"#96E6F0":"currentColor"}/>
                {sidebarOpen&&<span>{lb}</span>}
              </button>
            );
          })}
        </nav>
        {/* ── Integraciones ── */}
        <div style={{padding:"0 6px 4px"}}>
          <button className="nav btn" onClick={()=>setModal("integrations")}
            title={!sidebarOpen?"Integraciones":""}
            style={{width:"100%",display:"flex",alignItems:"center",
              gap:sidebarOpen?9:0,padding:sidebarOpen?"7px 10px":"7px 0",
              justifyContent:sidebarOpen?"flex-start":"center",
              borderRadius:8,border:"none",cursor:"pointer",fontFamily:"var(--font)",
              background:"transparent",color:"#8fb8c8",transition:"background .15s",position:"relative"}}
            onMouseEnter={e=>e.currentTarget.style.background="rgba(0,180,216,.12)"}
            onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <Icon name="plug" size={14} color="#8fb8c8"/>
            {sidebarOpen&&<span style={{fontSize:12}}>Integraciones</span>}
            {integrations.length>0&&(
              <span style={{position:sidebarOpen?"static":"absolute",top:2,right:2,
                width:8,height:8,borderRadius:"50%",background:"#22c55e",display:"inline-block",
                marginLeft:sidebarOpen?"auto":"0",flexShrink:0}}/>
            )}
          </button>
        </div>
        {/* ── Avatar usuario — anclado al fondo ── */}
        <div style={{borderTop:"1px solid #244b78",padding:"8px",flexShrink:0}}>
          <button className="nav btn" onClick={()=>go("profile")}
            title={!sidebarOpen?currentUser.name:""}
            style={{width:"100%",display:"flex",alignItems:"center",
              gap:sidebarOpen?9:0,padding:sidebarOpen?"8px 10px":"8px 0",
              justifyContent:sidebarOpen?"flex-start":"center",
              borderRadius:8,border:"none",cursor:"pointer",fontFamily:"var(--font)",
              background:"rgba(255,255,255,.05)",color:"#8fb8c8",transition:"background .15s"}}
            onMouseEnter={e=>e.currentTarget.style.background="rgba(0,180,216,.12)"}
            onMouseLeave={e=>e.currentTarget.style.background="rgba(255,255,255,.05)"}>
            <div style={{width:30,height:30,borderRadius:"50%",background:"linear-gradient(135deg,#086C76,#087DAB)",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:14,flexShrink:0}}>
              {currentUser.name[0].toUpperCase()}
            </div>
            {sidebarOpen&&<>
              <div style={{flex:1,minWidth:0,textAlign:"left"}}>
                <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"#cee8f0"}}>{currentUser.name}</div>
                <div style={{fontSize:10,color:"#8fb8c8",textTransform:"uppercase",letterSpacing:".06em"}}>{nombreRol(currentUser.role)}</div>
              </div>
              <Icon name="gear" size={12} color="#8fb8c8"/>
            </>}
          </button>
          <button className="nav btn" onClick={onLogout}
            title={!sidebarOpen?"Cerrar sesión":""}
            style={{width:"100%",display:"flex",alignItems:"center",
              gap:sidebarOpen?9:0,padding:sidebarOpen?"7px 10px":"7px 0",
              justifyContent:sidebarOpen?"flex-start":"center",
              borderRadius:8,border:"none",cursor:"pointer",fontFamily:"var(--font)",
              background:"transparent",color:"#fca5a5",transition:"background .15s",marginTop:2}}
            onMouseEnter={e=>e.currentTarget.style.background="rgba(239,68,68,.1)"}
            onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <Icon name="box-arrow-right" size={14} color="#fca5a5"/>
            {sidebarOpen&&<span style={{fontSize:12,fontWeight:600}}>Cerrar sesión</span>}
          </button>
        </div>
      </aside>
    </>
  );
}
